// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"d42e9671","962":"c81672f7"}[chunkId] + ".chunk.js";
};